import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDashboard } from '../../services/api';
import { pill } from '../pill';
import Button from '../ui/Button';

function StatCard({ label, value, color }) {
  return (
    <div style={{ background: '#ffffff', borderRadius: '12px', padding: '1.5rem', flex: 1, minWidth: '150px' }}>
      <div style={{ fontSize: '2rem', fontWeight: 700, color }}>{value}</div>
      <div style={{ color: '#6b7280', fontSize: '0.875rem', marginTop: '4px' }}>{label}</div>
    </div>
  );
}

function Badge({ compliant, active }) {
  if (!active) return <span style={badgeStyle('#e6e6e6', '#6b7280')}>Inactive</span>;
  if (!compliant) return <span style={badgeStyle('#fdecea', '#c62828')}>⚠ Non conforme</span>;
  return <span style={badgeStyle('#e2f3e8', '#1a7f37')}>✓ Conforme</span>;
}

const badgeStyle = pill;

export default function DashboardPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = () => {
    setLoading(true);
    getDashboard().then(setData).finally(() => setLoading(false));
  };

  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);

  // data null après l'appel = requête en échec (ex. token expiré pendant la
  // redirection vers /login) : ne pas planter le rendu.
  if (!data) return <p style={{ color: '#6b7280' }}>Chargement...</p>;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '2rem' }}>
        <h1 style={{ margin: 0, fontSize: '1.5rem' }}>Dashboard</h1>
        <Button onClick={load}>🔄 Actualiser</Button>
      </div>

      {/* KPIs */}
      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '2rem' }}>
        <StatCard label="Licences totales" value={data.totalLicenses} color="#005cc5" />
        <StatCard label="Licences actives" value={data.activeLicenses} color="#1a7f37" />
        <StatCard label="Instances actives" value={data.activeInstances} color="#5f37a8" />
        <StatCard label="Non conformes" value={data.nonCompliantLicenses} color={data.nonCompliantLicenses > 0 ? '#c62828' : '#1a7f37'} />
      </div>

      {/* Tableau des licences */}
      <div style={{ background: '#ffffff', borderRadius: '12px', overflowX: 'auto' }}>
        <div style={{ padding: '1rem 1.5rem', borderBottom: '1px solid #cdcdcd', fontWeight: 600 }}>
          Suivi par licence
        </div>
        <table style={{ width: '100%', minWidth: '760px', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #cdcdcd', color: '#8a8f99', fontSize: '0.8rem', textTransform: 'uppercase' }}>
              {['Client', 'Clé', 'Utilisateurs', 'Quota', 'Instances', 'Validité', 'Statut', ''].map(h => (
                <th key={h} style={{ padding: '0.75rem 1rem', textAlign: 'left' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.licenses.map(lic => (
              <tr key={lic.id} style={{ borderBottom: '1px solid #ececec', transition: 'background 0.1s' }}
                  className="ui-row">
                <td style={td}>{lic.clientName}</td>
                <td style={{ ...td, fontFamily: 'monospace', fontSize: '0.8rem', color: '#6b7280' }}>{lic.licenseKey}</td>
                <td style={{ ...td, fontWeight: 700, color: lic.currentUniqueUsers > lic.maxUsers ? '#c62828' : '#444444' }}>
                  {lic.currentUniqueUsers}
                </td>
                <td style={td}>{lic.maxUsers}</td>
                <td style={td}>{lic.instanceCount}</td>
                <td style={{ ...td, fontSize: '0.8rem', color: '#6b7280' }}>
                  {new Date(lic.validUntil).toLocaleDateString('fr-FR')}
                </td>
                <td style={td}><Badge compliant={lic.compliant} active={lic.active} /></td>
                <td style={td}>
                  <Button size="sm" onClick={() => navigate(`/licenses/${lic.id}`)}>Détail →</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const td = { padding: '0.85rem 1rem', color: '#444444' };
